import React, { useState, useEffect } from "react";
import { Modal } from "../../../../Components";


export default function ModalInfProfileExitConfirm(props) {
  const [confirmMessage, setConfirmMessage] = useState("");


  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="modal__camp">
        <div className="modal__assetDetail-delete perm long ">
          <h4>You have unsaved changes. <br />Are you sure you want to leave this page?</h4>

          <div className="modal__assetDetail-delete-btns confirmExit">
            <button className="button primary" onClick={props.onSaveProfile}>
              Save Changes and Go to Gallery
            </button>
            <button className="button secondary" onClick={props.discardAndGo}>
              Discard Changes and Go to Gallery
            </button>
            <button className="button secondary" onClick={props.stayOnPage}>
              Stay on Page
            </button>
          </div>





        </div>
      </div>
    </Modal>


  );
}

